<template>
  <div class="h-topmenu">
    <div class="h-topment-left">
      <div class="title-image">
        <img :src="logoStyle" /><span>{{systemTitle}}</span>
      </div>
      <div style="width:80px;">
        <!--./../assets/houtui.svg  ../../assets/qianjin.svg  ../../assets/shuaxin.svg -webkit-app-region:no-drag;-->
        <!-- <img class="app-left" src="" alt="" @click="A" title="后退">
        <img class="app-left" src="" alt="" @click="B" title="前进">
        <img class="app-left" src="" alt="" @click="C" title="刷新"> -->
      </div>
    </div>
    <div class="h-topment-middle">
      <!-- <div class="title-image">
                <img :src="logoStyle" /><span>{{systemTitle}}</span>
            </div> -->
      <h-button type="error" @click="homePage" v-if="showHomeBtn">官网</h-button>
      <div v-if="quotationBool">
        <h-button type="error" @click="ctlOrder">交易</h-button>
        <h-button type="error" @click="ctlQuotation">行情</h-button>
      </div>
    </div>
    <div class="h-topment-right" style="-webkit-app-region:no-drag;">
      <!-- <div class="" style="-webkit-app-region:no-drag;"> -->
      <p class="easy-btn" v-if="isLogin && lockHide" @click="logoff"><img class="app-left" src="../../assets/zhuxiao.svg" alt="" title="注销">
      </p>
      <p class="easy-btn" v-if="isLogin && lockHide" @click="setting"><img class="app-left" src="../../assets/shezhi.svg" alt="" title="设置">
      </p>
      <p class="easy-btn" v-if="isLogin && lockHide" @click="lock"><img class="app-left" src="../../assets/suoding.svg" alt="" title="锁定">
      </p>
      <p class="easy-btn" v-if="lockHide" @click="about"><img class="app-left" src="../../assets/about.svg" alt="" title="关于"></p>
      <p class="easy-btn" @click="minsize"><img class="app-left" src="../../assets/zuixiaohua.svg" alt="" title="最小化"></p>
      <p class="easy-btn" v-show="!imageflag" @click="reducingdown">
        <img class="app-left" src="../../assets/zdh.svg" alt="" title="最大化">
      </p>
      <p class="easy-btn" v-show="imageflag" @click="reducingdown">
        <img class="app-left" src="../../assets/xxhy.svg" alt="" title="向下还原">
      </p>
      <p class="close-btn" @click="closeBtn"><img class="app-close" src="../../assets/topClose.svg" alt="" title="关闭"></p>
      <!-- </div> -->
    </div>
    <h-msg-box v-model="show" :closable="false" :mask-closable="false" :isBeyond='true' width="1000" class="notice">
      <div slot="header" class="notice-header">
        <div class="notice-image">
          <img :src="logoStyle" /><span>选项</span>
        </div>
        <div class="notice-close">
          <img src="../../assets/notice-close.png" alt="" @click="close" title="关闭" />
        </div>
      </div>
      <div class="notice-body">
        <h-form :model="formLeft" label-position="left" :label-width="128" cols="2" style="width:600px;margin-left:10px;">
          <h-form-item label="系统通知时间间隔：" cols="2">
            <h-input v-model="inform" :filterRE="/^(0+)|[^\d]+/g" title="范围30-300" @on-blur="onblurA">
              <span slot="prepend" @click="prepend" accesskey="A">－</span>
              <span slot="append" @click="append" accesskey="A">＋</span>
            </h-input>
            <span class="minute">秒</span>
            <span class="info">重新登录后生效</span>
          </h-form-item>
          <h-form-item label="系统公告时间间隔：" cols="2">
            <h-input v-model="notice" :filterRE="/^(0+)|[^\d]+/g" title="范围30-300" @on-blur="onblurB">
              <span slot="prepend" @click="prepend" accesskey="B">－</span>
              <span slot="append" @click="append" accesskey="B">＋</span>
            </h-input>
            <span class="minute">秒</span>
            <span class="info">重新登录后生效</span>
          </h-form-item>
          <h-form-item label="每次显示最新公告前：" cols="2">
            <h-input v-model="showNum" :filterRE="/^(0+)|[^\d]+/g" title="范围1-100" @on-blur="onblurC">
              <span slot="prepend" @click="prepend" accesskey="C">－</span>
              <span slot="append" @click="append" accesskey="C">＋</span>
            </h-input>
            <span class="minute">条</span>
            <span class="info">重新登录后生效</span>
          </h-form-item>
          <h-form-item label="锁屏时间：" cols="2">
            <h-input v-model="time" :filterRE="/^(0+)|[^\d]+/g" title="范围10-99999" @on-blur="onblurD">
              <span slot="prepend" @click="prepend" accesskey="D">－</span>
              <span slot="append" @click="append" accesskey="D">＋</span>
            </h-input>
            <span class="minute">秒</span>
            <span class="info">立即生效</span>
          </h-form-item>
          <h-form-item label="跑马灯时间周期：" cols="2">
            <h-input v-model="marquee" :filterRE="/^(0+)|[^\d]+/g" title="范围30-1000" @on-blur="onblurE">
              <span slot="prepend" @click="prepend" accesskey="E">－</span>
              <span slot="append" @click="append" accesskey="E">＋</span>
            </h-input>
            <span class="minute">秒</span>
            <span class="info">重新登录后生效</span>
          </h-form-item>
        </h-form>
        <h-checkbox style="margin-left:8px;" v-model="isShow" @on-change="change">开启时显示最新公告</h-checkbox>
        <span style="margin-left:179px;">重新登录后生效</span>
        <div class="btn">
          <h-button @click="isOk()">确认</h-button>
          <h-button @click="close()">取消</h-button>
        </div>
      </div>
      <div slot="footer"></div>
    </h-msg-box>
  </div>
</template>
<script>
import { encrypt } from '@frame/utils/Utils'
import { unlockLogin } from '@frame/api/login/index'
import { getExtPublicKey } from '@frame/api/common/index'
import cloneDeep from 'clone-deep'
var myVar = null
export default {
  name: 'Topmenu',
  data () {
    return {
      show: false,
      inform: 300,
      notice: 300,
      showNum: 10,
      lockScreen: 120,
      time: 360,
      sleepTime: 0,
      marquee: 200,
      isShow: false,
      publicKey: '',
      unlockUser: {
        username: '',
        password: '',
        errInfo: '',
      },
      imageflag: true,
      lockHide: true,
      quotationBool: true,
      isLogin: false
    }
  },
  watch: {
    $route: {
      handler (to) {
        // 行情页面，顶部操作拦才显示行情，交易按钮
        this.quotationBool = (to.path === '/ctl-index' || to.path === '/quotation')
        // 通过token，确认是否登录，来显示隐藏，顶部锁屏，设置按钮
        if (this.$store.getters.token || window.localStore.get('token')) {
          this.isLogin = true
        } else {
          this.isLogin = false
        }
      },
      immediate: true,
      deep: true
    },
  },
  computed: {
    logoStyle () {
      return './static/images/notice.png'
    },
    systemTitle () {
      return window.LOCAL_CONFIG.SYS_NAME
    },
    showHomeBtn () {
      const { homeUrl } = window.LOCAL_CONFIG
      return !!homeUrl
    }
  },
  methods: {
    remain () {
      this.sleepTime--
      if (this.sleepTime === 0) {
        clearInterval(myVar)
        myVar = null
        this.render()
      }
    },
    render () {
      this.lockHide = false
      var that = this
      this.$hMsgBox.info({
        title: '已锁屏，请输入密码',
        width: 20,
        height: 30,
        top: 200,
        zIndex: 9999999,
        disableTabEvent: true,
        roundButton: false,
        render: (h) => {
          return h('Input', {
            props: {
              value: this.unlockUser.password,
              autofocus: true,
              type: 'password',
            },
            on: {
              input: (val) => {
                this.unlockUser.password = val
              },
            },
          })
        },
        beforeOkClose () {
          return new Promise((resolve, reject) => {
            let user = this.$getCurrInfo()
            if (typeof user !== 'undefined' && user !== null) {
              that.unlockUser.username = user['account']
            }
            let pwd = that.unlockUser.password
            let param = cloneDeep(that.unlockUser)
            param.password = encrypt(pwd, that.publicKey)
            unlockLogin(that.unlockUser.username, param.password).then(response => {
              const data = response.data
              if (data.errorNo === '0') {
                that.lockHide = true
                that.unlockUser.password = ''
                let ls = that.$localStore.get('lockScreen')
                that.lockScreen = ls
                that.sleepTime = ls
                console.log('解锁成功,重置锁屏时间:', that.sleepTime)
                resolve(true)
                myVar = setInterval(that.remain, 1000)
              } else if (data.errorNo === '201005') {
                console.log('密码不正确')
                that.unlockUser.password = ''
                that.$parent.$hMessage.error({ content: '密码不正确', offset: 300 })
                resolve(false)
              } else {
                console.log('密码不能为空')
                that.unlockUser.password = ''
                that.$parent.$hMessage.error({ content: '密码不能为空', offset: 300 })
                resolve(false)
              }
            }).catch(e => {
              console.error(e)
            })
          })
        }
      })
    },
    logoff () {
      let param = { 'text': '确认注销登录?', 'type': 1 }
      this.$store.dispatch('Logout', param).then(() => {
        clearInterval(myVar)
        myVar = null
        this.$localStore.set('reload', true)
        this.$myIpcSend.ipcSender(this.$router, 'login', 'logoff')
        this.$myIpcSend.renderer().removeAllListeners()
      }).catch(err => {
        console.error(err)
      })
    },
    setting () {
      this.show = true
      this.getSetting()
    },
    lock () {
      clearInterval(myVar)
      myVar = null
      this.sleepTime = 0
      this.render()
    },
    about () {
      this.$myIpcSend.ipcRemote().dialog.showMessageBox({
        type: 'info',
        title: `关于交易系统`,
        message: `交易系统 ${window.curVersion}`
      })
    },
    // 最小化
    minsize () {
      this.$myIpcSend.ipcSender(this.$router, 'minimize')
    },
    reducingdown () {
      this.$myIpcSend.ipcSender(this.$router, 'restore', !this.imageflag)
    },
    closeBtn (data = 0, data1 = 0) {
      let param = { 'text': '确认退出系统?', 'type': 1 }
      // 自动更新导致退出，使用type==0
      if (data === 1) {
        param = { 'text': '确认退出系统?', 'type': 0 }
      }

      // 行情页面，没有登录，直接退出
      if (this.$route.path === '/quotation') {
        this.signOut(param)
        return
      }

      this.$store.dispatch('Logout', param).then((res) => {
        if (res === 0) {
          this.$myIpcSend.ipcSender(this.$router, 'logout', data1)
        }
      }).catch(err => {
        console.error(err)
      })
    },
    // 行情-退出系统
    signOut (info) {
      window.myIpcSend.ipcRemote().dialog.showMessageBox(window.myIpcSend.ipcRemote().getCurrentWindow(), {
        type: 'info',
        title: '交易系统',
        buttons: ['ok', 'cancel'],
        message: info['text'],
        cancelId: 2
      }).then((res) => {
        if (res.response === 0) {
          this.$myIpcSend.ipcSender(this.$router, 'logout', info)
        }
      })
    },
    change (event) {
      this.isShow = event
    },
    isOk () {
      this.$localStore.set('inform', this.inform - 0)
      this.$localStore.set('notice', this.notice - 0)
      this.$localStore.set('showNum', this.showNum - 0)
      this.$localStore.set('lockScreen', this.time - 0)
      this.$localStore.set('marquee', this.marquee - 0)
      this.$localStore.set('isShow', this.isShow)
      this.lockScreen = this.time
      this.sleepTime = this.lockScreen
      this.show = false
    },
    close () {
      this.show = false
    },
    getSetting () {
      if (typeof (this.$localStore.get('inform')) !== 'undefined') {
        this.inform = this.$localStore.get('inform')
        this.notice = this.$localStore.get('notice')
        this.showNum = this.$localStore.get('showNum')
        this.time = this.$localStore.get('lockScreen')
        this.marquee = this.$localStore.get('marquee')
        this.isShow = this.$localStore.get('isShow')
        this.lockScreen = this.time
      } else {
        this.isOk()
      }
    },
    // 获取公钥
    getRsaPublickKey () {
      getExtPublicKey({}).then(r => {
        if (r.data.success) {
          this.publicKey = r.data.publicKey
        }
      }).catch(e => {
        console.log(e)
      })
    },
    prepend (event) {
      console.log('----------------------' + event)
      if (event.currentTarget.accessKey === 'A') {
        if (this.inform !== 30) {
          this.inform--
        }
      } else if (event.currentTarget.accessKey === 'B') {
        if (this.notice !== 30) {
          this.notice--
        }
      } else if (event.currentTarget.accessKey === 'C') {
        if (this.showNum !== 1) {
          this.showNum--
        }
      } else if (event.currentTarget.accessKey === 'D') {
        if (this.time !== 10) {
          this.time--
        }
      } else if (event.currentTarget.accessKey === 'E') {
        if (this.marquee !== 30) {
          this.marquee--
        }
      }
    },
    append (event) {
      console.log('+++++++++++++++++++++++++' + event)
      if (event.currentTarget.accessKey === 'A') {
        if (this.inform !== 300) {
          this.inform++
        }
      } else if (event.currentTarget.accessKey === 'B') {
        if (this.notice !== 300) {
          this.notice++
        }
      } else if (event.currentTarget.accessKey === 'C') {
        if (this.showNum !== 100) {
          this.showNum++
        }
      } else if (event.currentTarget.accessKey === 'D') {
        if (this.time !== 99999) {
          this.time++
        }
      } else if (event.currentTarget.accessKey === 'E') {
        if (this.marquee !== 1000) {
          this.marquee++
        }
      }
    },
    onblur (event) {
      console.log('+onblur+' + event)
      if (event.currentTarget.accessKey === 'A') {
        if (this.inform < 30) {
          this.inform = 30
        } else if (this.inform > 300) {
          this.inform = 300
        }
      } else if (event.currentTarget.accessKey === 'B') {
        if (this.notice < 30) {
          this.notice = 30
        } else if (this.notice > 300) {
          this.notice = 300
        }
      } else if (event.currentTarget.accessKey === 'C') {
        if (this.showNum < 1) {
          this.showNum = 1
        } else if (this.showNum > 100) {
          this.showNum = 100
        }
      } else if (event.currentTarget.accessKey === 'D') {
        if (this.time < 10) {
          this.time = 10
        } else if (this.time > 99999) {
          this.time = 99999
        }
      } else if (event.currentTarget.accessKey === 'E') {
        if (this.marquee < 30) {
          this.marquee = 30
        } else if (this.marquee > 1000) {
          this.marquee = 1000
        }
      }
    },
    onblurA () {
      if (this.inform < 30) {
        this.inform = 30
      } else if (this.inform > 300) {
        this.inform = 300
      }
    },
    onblurB () {
      if (this.notice < 30) {
        this.notice = 30
      } else if (this.notice > 300) {
        this.notice = 300
      }
    },
    onblurC () {
      if (this.showNum < 1) {
        this.showNum = 1
      } else if (this.showNum > 100) {
        this.showNum = 100
      }
    },
    onblurD () {
      if (this.time < 10) {
        this.time = 10
      } else if (this.time > 99999) {
        this.time = 99999
      }
    },
    onblurE () {
      if (this.marquee < 30) {
        this.marquee = 30
      } else if (this.marquee > 1000) {
        this.marquee = 1000
      }
    },
    /**
     * 官网
     */
    homePage () {
      const { homeUrl } = window.LOCAL_CONFIG
      this.$myIpcSend.openExternal(homeUrl)
    },
    /**
     * 行情
     * 当未登录时，显示登录框
    **/
    ctlOrder () {
      console.log('store--', this.$store)
      if (this.$store.getters.token || window.localStore.get('token')) {
        this.$bus.$emit('ctlPageOrder', 'middle')
      } else {
        console.log(345566)
        this.$myIpcSend.ipcSender(this.$router, 'qtLogin', '', '')
      }
    },
    ctlQuotation () {
      this.$bus.$emit('ctlPageOrder', 'none')
    }
  },
  created () {
    this.getRsaPublickKey()
  },
  mounted () {
    this.getSetting()
    window.addEventListener('keyup', () => {
      this.sleepTime = this.lockScreen
    })
    window.addEventListener('mousemove', () => {
      this.sleepTime = this.lockScreen
    })
    window.addEventListener('mousedown', () => {
      this.sleepTime = this.lockScreen
    })
    this.$myIpcSend.renderer().on('version', (event, data) => {
      window.curVersion = data.version
    })
    this.$myIpcSend.renderer().on('changeImage', (event, data) => {
      if (data === true) {
        this.imageflag = true
      } else {
        this.imageflag = false
      }
    })
    // 行情页面，没有锁屏
    if (this.$route.path !== '/quotation') {
      myVar = setInterval(this.remain, 1000)
    }
  },
  beforeDestroy () { // 在组件生命周期结束的时候销毁。
    if (myVar) {
      clearInterval(myVar)
      myVar = null
    }
  },
}
</script>
<style scoped lang="scss">
.h-topmenu {
  width: 100%;
  height: 30px;
  margin-bottom: 44px;
  background-color: #131520;
  position: absolute;
  z-index: 1202;
  display: flex;
  -webkit-app-region: drag;
}
.h-topment-left {
  width: 19%;
  -webkit-app-region: drag;
  line-height: 22px;
}
.h-topment-middle {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  &::before {
    content: '';
    flex: 1;
    -webkit-app-region: drag;
  }
  .h-btn {
    height: 24px;
    cursor: default;
    line-height: 1;
    margin-right: 10px;
    -webkit-app-region: no-drag;
  }
}
.h-topment-right {
  width: 180px;
  display: flex;
  -webkit-app-region: drag;
  align-items: center;
  justify-content: flex-end;
}
.h-topment-right p {
  width: 25px;
  height: 25px;
}
.app-left {
  margin-top: 4px;
  margin-right: 2px;
  width: 18px;
  height: 18px;
}
.h-topment-right .easy-btn:hover {
  background-color: #35393b;
}
.app-close {
  margin-top: 4px;
  margin-right: 2px;
  width: 14px;
  height: 14px;
}
.h-topment-right .close-btn:hover {
  background-color: red;
}
.h-topment-right /deep/ a {
  color: #707070 !important;
  cursor: default !important;
}
.notice /deep/ .h-modal-content {
  height: 340px !important;
  border-radius: 0px !important;
  background-image: url('../../assets/ucf_light_title_background.png');
  width: 420px !important;
  left: 50% !important;
  top: 50% !important;
  margin-left: -210px !important;
  margin-top: -170px !important;
}
.notice /deep/ .h-modal-header {
  border-bottom: 0px solid #f7f7f7 !important;
}
.notice /deep/ .h-modal-footer {
  border-top: 0px solid #f7f7f7 !important;
  padding: 0px !important;
}
.notice /deep/ .h-modal-body {
  border: 1px solid #999 !important;
  width: 410px !important;
  height: 305px !important;
  margin-left: 5px !important;
  margin-top: 2px !important;
  background-color: #e7e7e7 !important;
}
.notice /deep/ .h-form .h-form-item-label {
  background: none !important;
}
.notice-header {
  margin-top: -8px;
  margin-left: -11px;
}
.title-image {
  vertical-align: middle;
  text-align: left;
  margin-left: 16px;
}
.title-image img {
  width: 16px;
  vertical-align: middle;
  -webkit-app-region: no-drag;
}
.title-image span {
  /* color: white; */
  padding-left: 8px;
  font-size: 14px;
  vertical-align: middle;
  color: rgba(255, 255, 255, 0.7);
}
.notice-image {
  float: left;
}
.notice-image img {
  width: 20px;
  vertical-align: middle;
  -webkit-app-region: no-drag;
}
.notice-image span {
  color: white;
  padding-left: 8px;
  font-size: 14px;
  vertical-align: middle;
}
.notice-close {
  float: right;
  margin-top: -6px;
  margin-right: -16px;
}
.notice-close img {
  width: 30px;
  vertical-align: middle;
}
.notice-close:hover {
  background-color: red;
}
.notice-body {
  position: relative;
  margin-left: -33px;
  width: 405px;
}
.minute {
  margin-left: 5px;
}
.info {
  margin-left: 31px;
}
.notice-body /deep/ .h-input {
  text-align: center !important;
}
.notice-body /deep/ .h-input-type {
  margin-left: 0px !important;
  width: 123px !important;
}
.notice-body /deep/ .h-input-group-prepend {
  border-radius: 0px !important;
}
.notice-body /deep/ .h-input-group-prepend:hover {
  border-radius: 6px;
  background-color: #a9c6f3;
}
.notice-body /deep/ .h-input-group-append:hover {
  background-color: #a9c6f3;
}
.btn {
  margin-left: 267px;
  width: 150px;
  margin-top: 30px;
}
.btn /deep/ .h-btn {
  margin-left: 10px !important;
}
</style>
